import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    search: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'tool-tips/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_TOOL_TIPS_REQUEST,
                        types.SEARCH_TOOL_TIPS_SUCCESS,
                        types.SEARCH_TOOL_TIPS_FAILURE
                    ]
                }
            });
        },
    loadFilters: () =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'tool-tips/filters',
                    method: 'GET',
                    types: [
                        types.LOAD_TOOL_TIPS_FILTERS_REQUEST,
                        types.LOAD_TOOL_TIPS_FILTERS_SUCCESS,
                        types.LOAD_TOOL_TIPS_FILTERS_FAILURE
                    ]
                }
            });
        },
    save: (toolTip) =>
        (dispatch) => {
            if (toolTip.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'tool-tips/create',
                        method: 'POST',
                        body: toolTip,
                        types: [
                            types.CREATE_TOOL_TIPS_REQUEST,
                            types.CREATE_TOOL_TIPS_SUCCESS,
                            types.CREATE_TOOL_TIPS_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'tool-tips/update',
                        method: 'PUT',
                        body: toolTip,
                        types: [
                            types.UPDATE_TOOL_TIPS_REQUEST,
                            types.UPDATE_TOOL_TIPS_SUCCESS,
                            types.UPDATE_TOOL_TIPS_FAILURE
                        ]
                    }
                });
            }
            
    },
    dismissAndSave: (tipId) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'tool-tips/dismiss',
                    method: 'POST',
                    body: { toolTipId: tipId },
                    types: [
                        types.DISMISS_TOOL_TIP_REQUEST,
                        types.DISMISS_TOOL_TIP_SUCCESS,
                        types.DISMISS_TOOL_TIP_FAILURE
                    ]
                },
                payload: {
                    toolTipId: tipId
                }
            });
        },
    dismiss: (tipId) => ({
        type: types.DISMISS_TOOL_TIP_REQUEST,
        payload: {
            toolTipId: tipId
        }
    })
}